<template>

  <loading-view v-if="store.state.isLoading">
    <template #header>
      <div class="loading-logo">
        <img style="width: 10vh;margin-bottom: 0.5rem" src="@/assets/images/logo/Phoenix.png" alt="logo">
      </div>
    </template>
  </loading-view>

  <div class="sticky-element" id="navbar">
    <router-view name="navbar"></router-view>
  </div>
  <router-view name="default"></router-view>

</template>

<style lang="scss">
.sticky-element {
  position: sticky;
  top: 0;
  z-index: 9999;
  transition: 1s ease-in-out;
  //margin-bottom: 0.5vh;
}
</style>

<script setup>
import mythicalBeast from "@/script/mythicalBeast";
import {getAllDatas} from "@/axios/api";
import store from "@/store";
import LoadingView from "@/components/LoadingView.vue";

const responseData = await getAllDatas();

mythicalBeast.processBeastDataType(responseData.data);
mythicalBeast.rankDatas = responseData.rankData;

</script>